var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4315 8.5L4.2715 5.236C5.3635 5.14 6.3595 4.348 6.3595 2.908C6.3595 1.432 5.3035 0.495999 3.8395 0.495999H0.6235V8.5H1.6195V5.32H3.2275L5.2555 8.5H6.4315ZM3.7195 4.444H1.6195V1.384H3.7195C4.6675 1.384 5.3275 1.996 5.3275 2.908C5.3275 3.808 4.6675 4.444 3.7195 4.444Z",
    fill: "#A8ACAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRKey);
export default __webpack_public_path__ + "static/media/icon-r-key.98b000f436238d43f3e1d81c22cdcff9.svg";
export { ForwardRef as ReactComponent };